import { environment } from '../../../environments/environment';

export function isTest() {
  return (
    environment.apiPath === 'https://apitestct.pibank.ws/api' ||
    environment.apiPath === '/api-base-path/'
  );
}
